
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class AppBreadcrumbs extends Vue {
  @Prop({default: () => []}) items!: any[];

  get breadcrumbs() {
    /* eslint-disable */
    const routeBreadcrumbs = this.$route?.meta?.breadcrumbs || [];
    return [
      // {
      //   text: t('home'),
      //   to: '/',
      //   exact: true,
      // },
      /* eslint-disable */
      ...routeBreadcrumbs,
      ...this.items,
    ];
  }
}
